import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter} from 'react-router-dom';
import { orderBy, map, filter } from 'lodash';
import classNames from 'classnames';
import { Pitch } from '@monpetitgazon/mpg-pitch';
import domtoimage from 'dom-to-image';
import $ from 'jquery';
import { Championship } from "@monpetitgazon/mpg-team-graphics";

import selectEntities from "../../../../../selectors/entities";
import { fetchPlayersForDlIfNeeded } from '../../../../../actions/app/tools/dlpicture';

import './DlPictureWidget.css';
import Loader from '../../../../../components/Loader';
import { ChampionshipSelector } from "../../../../../components/ChampionshipSelector";
import { teamsPosition } from "../../../../../helpers/teamsPosition";

const initialState = {
    championship: 1,
    compo: 541,
    playersOnPitch: [null, null, null, null, null, null, null, null, null, null, null],
    players: [],
    position: "",
    logo: null,
    orderBy: 'club',
    sortOrder : 'asc',
    filters: {}
};

class DlPictureWidget extends React.Component {
    constructor(props) {
        super(props);

        const state = initialState;
        if (props.championship) state.championship = props.championship;

        this.state = state;
    }

    componentDidMount(){
        this.fetchPlayersList();
        this.updateLogo();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.championship !== this.state.championship){
            this.fetchPlayersList();
            this.updateLogo();
        }
        if (prevState.orderBy !== this.state.orderBy || prevState.sortOrder !== this.state.sortOrder)
            this.setState({ players: this.orderPlayers(this.state.players) });

        if (prevState.filters !== this.state.filters)
            this.setState({ players: this.orderPlayers(this.filterPlayers(this.props.entities)) });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.entities && (nextProps.entities !== this.props.entities))
            this.setState({ players: this.orderPlayers(nextProps.entities) });
    }

    updateLogo() {
        const logos = { 1: 'mpg', 2: 'mln', 3: 'mgd' };
        this.setState({ logo: logos[this.state.championship] });
    }

    fetchPlayersList(e) {
        if (e) e.preventDefault();
        const { championship } = this.state;
        this.props.dispatch(fetchPlayersForDlIfNeeded({championship}));
    }

    orderPlayers(players) {
        // The switch is necessary for the default second order of each orderType
        switch (this.state.orderBy) {
            case 'club':
                return orderBy(players, ['club', 'position'], [this.state.sortOrder, 'asc']);
            case 'name':
                return orderBy(players, ['lastname', 'rating'], [this.state.sortOrder, 'desc']);
            case 'position':
                return orderBy(players, ['position', 'lastname'], [this.state.sortOrder, 'asc']);
            case 'rating':
                return orderBy(players, ['rating', 'lastname'], [this.state.sortOrder, 'desc']);
            default:
                return orderBy(players, ['club', 'lastname'], [this.state.sortOrder, 'asc']);
        }
    }

    changeChampionship(championship) {
        this.setState({ championship });
        this.props.history.replace({
            pathname: this.props.location.pathname,
            search: `?championship=${championship}`
        })
    }

    handleChange(event){
        this.setState({compo: parseInt(event.target.value, 10)});
    }

    hideLogo(){
        if (this.state.logo) this.setState({logo: null});
        else { this.updateLogo(); }
    }

    downloadPic(){
        domtoimage.toPng(document.getElementsByClassName('body')[0])
            .then(function (dataUrl) {
                let img = new Image();
                img.src = dataUrl;
                let a = $("<a>").attr("href", dataUrl).attr("download", "img.png").appendTo("body");
                a[0].click();
                a.remove();
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    selectOrChangeOrder(orderType) {
        if (orderType === this.state.orderBy)
            this.setState({ sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc'});
        else {
            this.setState({ orderBy: orderType });
            // The switch is necessary for the default sortOrder each orderType
            switch (orderType) {
                case 'club':
                    this.setState({ sortOrder: 'asc' });
                    break;
                case 'name':
                    this.setState({ sortOrder: 'asc' });
                    break;
                case 'position':
                    this.setState({ sortOrder: 'asc' });
                    break;
                case 'rating':
                    this.setState({ sortOrder: 'asc' });
                    break;
                default:
                    this.setState({ sortOrder: 'asc' });
            }
        }
    }

    getOrderCaret(orderType) {
        if (orderType !== this.state.orderBy)
            return false;

        return `fa-caret-${this.state.sortOrder === 'desc' ? 'down' : 'up'}`
    }

    filterPlayers(players) {
        map(this.state.filters, (value, key) => {
            if (value && value !== '') {
                switch (key) {
                    case 'name':
                        players = filter(players, player => player.lastname.match(new RegExp(value,"gi")));
                        break;
                    case 'club':
                        players = filter(players, { teamid: value});
                        break;
                    case 'position':
                        players = filter(players, { position: parseInt(value, 10) });
                        break;
                    default:
                        return players;
                }
            }
        });

        return players;
    }

    renderPlayers() {
        const positions = ['Goal Keeper', 'Defender', 'Midfielder', 'Striker'];
        const { players } = this.state;

        return (
            <div className="table-responsive table-fixed-height">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>
                            <a onClick={() => this.selectOrChangeOrder('name')}>
                                Name&nbsp;
                                <i className={classNames('fa', this.getOrderCaret('name'))}/>
                            </a>
                        </th>
                        <th>
                            <a onClick={() => this.selectOrChangeOrder('club')}>
                                Club&nbsp;
                                <i className={classNames('fa', this.getOrderCaret('club'))}/>
                            </a>
                        </th>
                        <th>
                            <a onClick={() => this.selectOrChangeOrder('position')}>
                                Position&nbsp;
                                <i className={classNames('fa', this.getOrderCaret('position'))}/>
                            </a>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        players.map(({id, firstname, lastname, teamid, club, position, quotation}, key) => {
                            teamid = parseInt(teamid, 10);
                            return(
                                <tr onClick={this.getPlayer.bind(this,{lastname, teamid, club, position, name: lastname} )} key={key} id={id} className="player">
                                    <th>{firstname} <span className="text-uppercase">{lastname}</span></th>
                                    <td data-id={teamid}>{club}</td>
                                    <td>{positions[position-1]}</td>
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }

    onSelectPlayer = (index) => {
        this.setState({position: index.position})
    };

    getPlayer(player){
        let tmp = this.state.playersOnPitch;
        if (this.state.position) tmp[this.state.position - 1] = player;
        this.setState({playersOnPitch: tmp});
    }

    refresh(){
        this.setState({playersOnPitch: [null, null, null, null, null, null, null, null, null, null, null]})
    }

    resetFilters = () => {
        document.getElementById("filter2").value = "";
        document.getElementById("filter3").value = "";

        this.setState({
            filters: {},
            orderBy: 'club',
            sortOrder : 'asc'
        });
    };

    render() {
        const { championship } = this.state;
        const activeTeams = new Championship(this.state.championship).getActiveTeams();
        const clubOptions = orderBy(activeTeams, ['label'], ['asc']);
        return (
            <div id="dl-picture-widget" className="row">
                <div className="col-md-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title pull-left">
                                <i className="fa fa-thumbs-up"/> Team pictures
                            </h3>
                            <div className="box-tools pull-right">
                                <ChampionshipSelector
                                    championship={championship}
                                    onChange={(c) => this.changeChampionship(c)}
                                />
                            </div>
                        </div>
                        <div className="box-footer">
                            <div className="row">
                                <div className="col-sm-6 col-md-3">
                                    <button
                                        onClick={this.hideLogo.bind(this)}
                                        type="button"
                                        className="btn btn-default btn-block"
                                    >
                                        <i className="fa fa-eye-slash"/> Hide Logo
                                    </button>
                                </div>
                                <div className="col-sm-6 col-md-3">
                                    <button
                                        onClick={this.downloadPic.bind(this)}
                                        type="button"
                                        className="btn btn-default btn-block"
                                    >
                                        <i className="fa fa-picture-o"/> Download picture
                                    </button>
                                </div>
                                <div className="col-sm-6 col-md-3">
                                    <button
                                        onClick={this.refresh.bind(this)}
                                        type="button"
                                        className="btn btn-warning btn-block"
                                    >
                                        <i className="fa fa-trash"/> Reset pitch
                                    </button>
                                </div>
                                <div className="col-sm-6 col-md-3">
                                    <button
                                        type="button"
                                        onClick={this.resetFilters}
                                        className="btn btn-warning buttonReset btn-block">
                                        <i className="fa fa-times"/> Reset filters
                                    </button>
                                </div>
                            </div>
                            <br/>
                            <div className="row">
                                <div className="col-md-3">
                                    <form>
                                        <div className="form-group">
                                            <select
                                                onChange={this.handleChange.bind(this)}
                                                className="form-control"
                                            >
                                                {teamsPosition.map((item, index) => {
                                                    return (<option key={index} value={item.value}>{item.label}</option>)
                                                })}
                                            </select>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-sm-3">
                                    <select
                                        id = "filter2"
                                        className="form-control"
                                        value={this.state.filters.club}
                                        onChange={e => this.setState({ filters: {
                                                ...this.state.filters,
                                                club: e.target.value
                                            }, groupTeam: e.target.value })}
                                        disabled={this.props.page.info.isFetching}
                                    >
                                        <option value="">All clubs</option>
                                        {clubOptions.map((option, key) => (
                                            <option  key={key} value={option.value || option.id}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-sm-3">
                                    <select
                                        id = "filter3"
                                        className="form-control"
                                        value={this.state.filters.position}
                                        onChange={e => this.setState({ filters: {
                                                ...this.state.filters,
                                                position: e.target.value
                                            } })}
                                        disabled={this.props.page.info.isFetching}
                                    >
                                        <option value="">All positions</option>
                                        <option value="1">Goal Keepers</option>
                                        <option value="2">Defenders</option>
                                        <option value="3">Midfielders</option>
                                        <option value="4">Strikers</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <form>
                                        <input
                                            type="text" className="form-control"
                                            placeholder="Name of a player"
                                            onChange={e => this.setState({ filters: {
                                                    ...this.state.filters,
                                                    name: e.target.value.length > 2 ? e.target.value : '',
                                                } })}
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Pitch
                                        formation={this.state.compo}
                                        logo="MPG"
                                        onPlayerClick={this.onSelectPlayer}
                                        players={this.state.playersOnPitch}
                                        ultra
                                        noTippy
                                    />
                                </div>
                                <div className="col-md-6">
                                 {this.state.players && this.renderPlayers()}
                                </div>
                            </div>
                        </div>
                        {this.props.page.info.isFetching && this.state.players && <Loader/>}
                    </div>
                </div>
            </div>
        )
    }
}

DlPictureWidget.propTypes = {
    championship: PropTypes.number,
};

export default withRouter(connect(
    state => ({
        entities: selectEntities(state.entities.players, state.app.tools.dlpicture.ids),
        page: state.app.tools.dlpicture}),
    dispatch => ({ dispatch })
)(DlPictureWidget));



// WEBPACK FOOTER //
// ./src/pages/Tools/DlPicture/Widgets/DlPictureWidget/index.js